import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AccordionSubTitle } from '../model/accordion-subtitle.model';

let nextId = 0;

@Component({
  selector: 'vm-accordion-title-bar',
  templateUrl: './accordion-title-bar.component.html',
  styleUrls: ['./accordion-title-bar.component.scss'],
})
export class AccordionTitleBarComponent {
  @Input() icon: string;
  @Input() image: string;
  @Input() subTitles: AccordionSubTitle[] = [];
  @Input()
  get isActive() {
    return this.active;
  }
  set isActive(isActive: boolean) {
    this.active = isActive;
  }
  @Input() contentDisabled = false;
  @Output() toggleActive = new EventEmitter<boolean>();

  id = `${nextId++}`;
  active = false;
  titleId: string;

  toggle() {
    if (this.contentDisabled) {
      return;
    }
    this.active = !this.active;
    this.toggleActive.emit(this.active);
  }

  get classes() {
    const cssClasses = {};

    if (this.icon) {
      cssClasses['fa-' + this.icon] = true;
    }

    return cssClasses;
  }
}
